module.exports = __webpack_public_path__ + "static/media/1323.97cbd002.gif";